/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { logger as log } from '@common/logger';

import { Client, Provider, cacheExchange, fetchExchange } from 'urql';
import { Graphql } from '@common/graphql';
import { Sttp } from '@common/sttp';
import { vappContainer } from '@/application';
import { AppNavigatorService } from '@/AppNavigator';
import { apiConfig } from '@pages/AdminPage/config/api.config';
import { reinviteUserConfig } from '@pages/AdminPage/config/reInviteUser.config';
import { REINVITE_CREDIT_UNION_USER } from '@pages/AdminPage/api/graphql';

const getWhoamiSrv = () => {
  return vappContainer.get<AppNavigatorService>(
    AppNavigatorService.displayName
  );
};

export interface ReInviteUserProps {
  email: string;
  firstName: string;
  lastName: string;
  invite: boolean;
  loginRestAPI: string;
  headers: any;
  termsOfUse: any;
}

export interface IReInviteUserPluginMethods extends IPluginMethodMap {
  getReInviteUserSync(args?: any): any;
}

export class ReInviteUserPlugin implements IAgentPlugin {
  readonly methods: IReInviteUserPluginMethods;

  constructor() {
    this.methods = {
      getReInviteUserSync: this.getReInviteUserSync.bind(this),
    };
  }

  async getReInviteUserSync(args?: ReInviteUserProps) {
    await new Promise((r) => setTimeout(r, 2000));
    await this.reInviteUser();
    //   return {
    //   reinvite:reinviteUserConfig
    //  };
  }

  //Graphql Query example
  async reInviteUser(args?: any) {
    let gql = Graphql.withBaseUrl(apiConfig.gql.url);
    const token = getWhoamiSrv()?.getToken();
    //const token = null;
    if (token) {
      gql = gql.withHeaders({
        authentication: token,
      });
    }
    const client = gql.getClient();
    try {
      if (client) {
        const res = await client
          .mutation(REINVITE_CREDIT_UNION_USER, {
            vuid: args,
          })
          .toPromise();
        if (res?.data) {
          console.log(`table data`, res);
          return {
            ...res?.data,
          };
        }
      }
    } catch (err: any) {
      // log.log('result of update profile=', res?.data?.capsules);
      log.error('error in activate User', err?.message);
      throw err;
    }
  }
}
